import ProbabilityHome from './Probability/ProbabilityHome';

import 'bootstrap/dist/css/bootstrap.min.css';

function App() {
  return (
    <div>
      <ProbabilityHome />
    </div>
  );
}

export default App;
